import { call, put, takeEvery } from 'redux-saga/effects';
import { getLeadsStatus } from '../../requests/get_leads_status_request';
import { getLeadsStatusSuccess, getLeadsStatusFailure } from '../actions/get_leads_status.actions';
import { GET_LEADS_STATUS } from '../constants/leads_status.constants';

function* getLeadsStatusRequest() {
    const lead_status_list = yield call(getLeadsStatus);
    lead_status_list
        ? yield put(getLeadsStatusSuccess(lead_status_list))
        : yield put(getLeadsStatusFailure('Something gone wrong!'));
}

export default function* getLeadsStatusSaga() {
    yield takeEvery(GET_LEADS_STATUS, getLeadsStatusRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/get_lead_status.saga.js